/* Interactive Menu JS — indépendant, support multi-sections .im[data-section-id] */

(function(){
  // Utilitaire pour attacher une seule fois des handlers globaux
  var once = function(key, fn){
    if (window.__imFlags && window.__imFlags[key]) return;
    window.__imFlags = window.__imFlags || {};
    window.__imFlags[key] = true;
    try { fn(); } catch(_){}
  };

  // Init par section
  document.querySelectorAll('.im[data-section-id]').forEach(function(root){
    // Vars dynamiques transmises par data-* et CSS vars
    var DATA = root.dataset || {};
    var PANEL_MS = parseInt(DATA.animMs || '500', 10);
    var BLUR_MS  = parseInt(DATA.animBlurMs || '500', 10);
    var STAGGER  = parseInt(DATA.stagger || '32', 10);

    // Flag body pour neutraliser les spacers de thème
    document.body.classList.add('im-has-transparent-header');

    // ---------- Overlay factory ----------
    function makeOverlayAPI(side){
      var ovlRoot = root.querySelector(side === 'L' ? '#im-ovlL' : '#im-ovlR');
      if (!ovlRoot) return null;
      var btnEl    = ovlRoot.querySelector('.im-ovl__toggle');
      var panel    = ovlRoot.querySelector('.im-ovl__panel');
      var backdrop = ovlRoot.querySelector('[data-backdrop]');
      var links    = Array.prototype.slice.call(ovlRoot.querySelectorAll('.im-ovl__item .im-ovl__link'));
      var MQ_MOBILE = window.matchMedia('(max-width: 768px)');
      var MAX_MS = Math.max(PANEL_MS, BLUR_MS) + Math.max(0, links.length - 1) * STAGGER;

      // >>> PATCH: Mobile-safe navigation to ensure link taps navigate even if overlay closes (iOS/Safari) <<<
      links.forEach(function(a){
        a.addEventListener('click', function(ev){
          if (!MQ_MOBILE.matches) return; // desktop: native behavior
          var href = a.getAttribute('href');
          if (!href || href === '#') return;
          ev.preventDefault();
          try { close(); } catch(_){}
          setTimeout(function(){ window.location.assign(href); }, 60);
        }, {capture:false});
      });
      // >>> END PATCH <<<

      // Scroll lock sans bouger la scrollbar
      var scrollKeys = new Set(['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ']);
      var lockActive = false;
      function onWheel(e){ e.preventDefault(); }
      function onTouch(e){ e.preventDefault(); }
      function onKey(e){ if (scrollKeys.has(e.key)) e.preventDefault(); }
      function lockScroll(){
        if (lockActive) return; lockActive = true;
        window.addEventListener('wheel', onWheel, {passive:false, capture:true});
        window.addEventListener('touchmove', onTouch, {passive:false, capture:true});
        window.addEventListener('keydown', onKey, {passive:false, capture:true});
      }
      function unlockScroll(){
        if (!lockActive) return; lockActive = false;
        window.removeEventListener('wheel', onWheel, {capture:true});
        window.removeEventListener('touchmove', onTouch, {capture:true});
        window.removeEventListener('keydown', onKey, {capture:true});
      }

      function doubleRAF(fn){ requestAnimationFrame(function(){ requestAnimationFrame(fn); }); }
      function afterTransition(cb){ setTimeout(cb, MAX_MS + 120); }
      function applyStagger(opening){
        var n = links.length;

        // --- Desktop only: ralentir Explore (panneau gauche) ---
        var step = STAGGER;
        if (!MQ_MOBILE.matches && side === 'L') {
          // x2 (ajuste à 2.5 ou 3 si tu veux encore plus lent)
          step = Math.round(STAGGER * 2.2);
        }

        for (var i=0; i<n; i++){
          var link = links[i];
          var delay = opening ? i * step : (n - 1 - i) * step;
          link.style.transitionDelay = (delay / 1000) + 's';
        }
      }
      function clearStagger(){ links.forEach(function(l){ l.style.transitionDelay = ''; }); }

      // Libellés (desktop = contenus HTML, mobile = data-*)
      var labelLeftDesktop  = (root.querySelector('#im-ovlL .im-ovl__toggle') || {}).textContent || 'Explore';
      var labelRightDesktop = (root.querySelector('#im-ovlR .im-ovl__toggle') || {}).textContent || 'More';
      var mobileMenuLabel   = DATA.mobileMenuLabel  || 'Menu';
      var mobileCloseLabel  = DATA.mobileCloseLabel || 'Close';

      function setButtonLabel(open){
        if (!btnEl) return;
        if (MQ_MOBILE.matches){
          if (side === 'L') btnEl.textContent = open ? mobileCloseLabel : mobileMenuLabel;
        } else {
          btnEl.textContent = side === 'L' ? labelLeftDesktop : labelRightDesktop;
        }
      }
      setButtonLabel(false);
      if (MQ_MOBILE.addEventListener){
        MQ_MOBILE.addEventListener('change', function(){ setButtonLabel(root.classList.contains('ovl-open-'+side)); });
      }

      function open(){
        if (side === 'L' && root.classList.contains('ovl-open-R')) { if (apis.R) apis.R.close(true); }
        if (side === 'R' && root.classList.contains('ovl-open-L')) { if (apis.L) apis.L.close(true); }
        applyStagger(true);
        root.setAttribute('data-ovl-anim','open-' + side);
        doubleRAF(function(){
          root.classList.add('ovl-open-' + side);
          if (side === 'L' && MQ_MOBILE.matches){
            root.classList.add('ovl-open-R'); // sur mobile on montre aussi le panel right
          }
          panel.setAttribute('aria-hidden','false');
          if (btnEl) btnEl.setAttribute('aria-expanded','true');
          setButtonLabel(true);
          lockScroll();
        });
      }
      function close(){
        applyStagger(false);
        root.setAttribute('data-ovl-anim','close-' + side);
        doubleRAF(function(){
          root.classList.remove('ovl-open-' + side);
          if (side === 'L' && MQ_MOBILE.matches){
            root.classList.remove('ovl-open-R');
          }
          panel.setAttribute('aria-hidden','true');
          if (btnEl) btnEl.setAttribute('aria-expanded','false');
          setButtonLabel(false);
          afterTransition(function(){
            if (!root.classList.contains('ovl-open-L') && !root.classList.contains('ovl-open-R')){
              root.setAttribute('data-ovl-anim','idle');
              clearStagger();
              unlockScroll();
            } else {
              clearStagger();
            }
          });
        });
      }
      function toggle(){ root.classList.contains('ovl-open-' + side) ? close() : open(); }

      if (btnEl) btnEl.addEventListener('click', toggle);
      if (backdrop) backdrop.addEventListener('click', close);
      document.addEventListener('click', function(e){
        if (!root.classList.contains('ovl-open-' + side)) return;
        // --- MOBILE GUARD: keep right panel open while left is open ---
        if (MQ_MOBILE.matches && side === 'R' && root.classList.contains('ovl-open-L')) {
          return; // ignore outside clicks so the right stays visible when left is open
        }

        var inside = panel.contains(e.target) || (btnEl && btnEl.contains(e.target));
        if (!inside) close();
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && root.classList.contains('ovl-open-' + side)) close();
      });
      panel.addEventListener('click', function(e){
        // Prevent closing when manipulating the language switcher inside the left panel
        if (e.target.closest('.tl-switcher, .tl-options, .tl-select, .tl-option')) {
          e.stopPropagation();
          return;
        }
        var a = e.target.closest('a'); if (a) close();
      });
      // Also guard mousedown for some dropdowns that bind earlier
      panel.addEventListener('mousedown', function(e){
        if (e.target.closest('.tl-switcher, .tl-options, .tl-select, .tl-option')) {
          e.stopPropagation();
        }
      });

      return { open: open, close: close, toggle: toggle };
    }

    var apis = { L: makeOverlayAPI('L'), R: makeOverlayAPI('R') };

    // Burger -> overlay gauche (optionnel) ou drawer mobile natif
    var burger  = root.querySelector('.im__burger');
    var drawer  = root.querySelector('.im-mobile-drawer');
    // Par défaut: ouvre l’overlay
    if (burger){
      burger.addEventListener('click', function(){
        if (apis.L) apis.L.toggle();
        else if (drawer){
          var exp = burger.getAttribute('aria-expanded') === 'true';
          burger.setAttribute('aria-expanded', String(!exp));
          drawer.toggleAttribute('hidden');
        }
      });
    }

    // ---- Cart drawer bridge (ouvre le drawer via l’event global 'cart:open') ----
    document.addEventListener('click', function(e){
      var a = e.target.closest('[data-cart-open]');
      if(!a) return;
      e.preventDefault();
      try { document.dispatchEvent(new CustomEvent('cart:open')); } catch(_){}
    }, true);

    // Mise à jour compteur (desktop = "(n)", mobile pill = "n")
    function updateCartCount(){
      fetch('/cart.js')
        .then(function(r){ return r.json(); })
        .then(function(cart){
          root.querySelectorAll('.im-cart-link [data-cart-count]').forEach(function(el){
            el.textContent = '(' + cart.item_count + ')';
          });
          root.querySelectorAll('.im-mobile-cart [data-cart-count], .im-header-cart [data-cart-count]').forEach(function(el){
            el.textContent = String(cart.item_count);
          });
        }).catch(function(){});
    }
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (f && f.action && f.action.indexOf('/cart/add') > -1){
        setTimeout(function(){ updateCartCount(); try{ document.dispatchEvent(new CustomEvent('cart:open')); }catch(_){ } }, 600);
      }
    });
    document.addEventListener('cart:refresh', function(){ updateCartCount(); });
  });
})();
/* === [PATCH 2025-10-02] Mobile overlay hard-lock (interactive-menu) === */
(function(){
  try{
    var root = document.querySelector('.im'); if(!root) return;
    var MQ = window.matchMedia('(max-width: 768px)');

    function sync(){
      var open = root.classList.contains('ovl-open-L') || root.classList.contains('ovl-open-R');
      if (open && MQ.matches){
        document.documentElement.classList.add('im-ovl-fixed');
        document.body.classList.add('im-ovl-fixed');
      } else {
        document.documentElement.classList.remove('im-ovl-fixed');
        document.body.classList.remove('im-ovl-fixed');
      }
    }

    var mo = new MutationObserver(sync);
    mo.observe(root, {attributes:true, attributeFilter:['class']});

    if (MQ.addEventListener) MQ.addEventListener('change', sync);
    else if (MQ.addListener) MQ.addListener(sync);
    window.addEventListener('orientationchange', sync, {passive:true});
    document.addEventListener('visibilitychange', sync, {passive:true});
    sync();

    // Stop propagation sur le menu Explore de gauche pour éviter un reflow parasite
    var leftPanel = document.querySelector('#im-ovlL .im-ovl__panel');
    if (leftPanel){
      ['touchstart','click'].forEach(function(type){
        leftPanel.addEventListener(type, function(e){
          if (e.target && e.target.closest('.im-ovlL__secondary .im-ovl__menu')){
            e.stopPropagation();
          }
        }, {passive:true, capture:true});
      });
    }
  }catch(err){
    console && console.warn && console.warn('[interactive-menu][patch]', err);
  }
})();

/* [PATCH cart-bubble-visibility v2] */
(function(){
  function updateMobileCartBubble() {
    var mobileNodes = document.querySelectorAll('.im-header-cart [data-cart-count], .header__cart-count [data-cart-count]');
    for (var i=0;i<mobileNodes.length;i++) {
      var el = mobileNodes[i];
      var txt = (el.textContent || '').trim();
      var num = parseInt(txt.replace(/\D/g,''), 10);
      if (isNaN(num)) num = 0;
      el.style.display = (num > 0) ? 'inline-block' : 'none';
    }
    var desktopNodes = document.querySelectorAll('.im-cart-count[data-cart-count]');
    for (var j=0;j<desktopNodes.length;j++) {
      desktopNodes[j].style.display = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateMobileCartBubble, { once: true });
  } else {
    updateMobileCartBubble();
  }

  var mo = new MutationObserver(updateMobileCartBubble);
  function observeTargets(){
    var targets = document.querySelectorAll('.im-header-cart [data-cart-count], .header__cart-count [data-cart-count], .im-cart-count[data-cart-count]');
    for (var i=0;i<targets.length;i++) {
      mo.observe(targets[i], { childList: true, characterData: true, subtree: true });
    }
  }
  observeTargets();

  var domObserver = new MutationObserver(function(){ observeTargets(); updateMobileCartBubble(); });
  domObserver.observe(document.documentElement, { childList: true, subtree: true });

  ['cart:updated','cart:update','cart:change'].forEach(function(evt){
    document.addEventListener(evt, updateMobileCartBubble);
  });
})();

/* === [PATCH] Normalize cart count text to raw number; CSS handles () on desktop === */
(function(){
  function getCountFromText(text){
    var m = (text || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }
  function formatOne(el){
    if(!el) return;
    var n = getCountFromText(el.textContent);
    el.textContent = String(n);
  }
  function formatAll(root){
    (root || document).querySelectorAll('[data-cart-count]').forEach(formatOne);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ formatAll(); });
  } else {
    formatAll();
  }
  var mo = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      if (m.type === 'characterData'){
        var p = m.target && m.target.parentElement;
        if (p && p.matches && p.matches('[data-cart-count]')) formatOne(p);
      } else if (m.type === 'childList'){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (node.nodeType === 1){
            if (node.matches && node.matches('[data-cart-count]')) formatOne(node);
            else formatAll(node);
          }
        });
      }
    });
  });
  mo.observe(document.documentElement, { subtree:true, childList:true, characterData:true });
  try { document.addEventListener('cart:updated', function(){ formatAll(); }, true); } catch(_) {}
})();

